import React, { useEffect, useState } from "react";
import CurrencyEnabler from "../CurrencyEnabler";

import "./CurrencyCollection.scss";
import { Checkbox } from "@material-ui/core";

const CurrencyCollection = (props: {
  currencies?: any[];
  denominations?: any[];
  onSelectCurrency?: (s: string) => void;
  onEnable?: (currency: any, enabled: boolean) => void;
  onEnableDenomination?: (denom: any, enabled: boolean) => void;
  denominationsLoading?: boolean;
}) => {
  const [busy, setBusy] = useState<boolean>(false);

  useEffect(() => {
    if (!props.denominationsLoading) {
      setBusy(false);
    }
  }, [props.denominationsLoading]);

  return (
    <div className="Configuration-container">
      <table className="CurrencyCollection-container">
        <thead className="CurrencyCollection--headPanel">
          <tr className="CurrencyCollection--headPanelRow">
            <th>Enabled</th>
            <th>Currency Code</th>
            <th>Currency Name</th>
          </tr>
        </thead>
        <tbody>
          {props.currencies &&
            props.currencies.map((c: any, index: number) => (
              <CurrencyEnabler
                index={index}
                currency={c}
                onCheck={async (enabled: boolean) => {
                  if (props.onEnable) {
                    setBusy(true);
                    await props.onEnable(c, enabled);
                  }
                }}
                onRowSelect={props.onSelectCurrency}
              />
            ))}
        </tbody>
      </table>
      <table className="CurrencyDenominations-container">
        <thead className="CurrencyDenominations--headPanel">
          <tr className="CurrencyDenominations--headPanelRow">
            <th>Enabled</th>
            <th>Denominations</th>
          </tr>
        </thead>
        <tbody>
          {props.denominations &&
            props.denominations.map(d => (
              <tr className="CurrencyDenominations-row">
                <td className="CurrencyDenominations-enabled">
                  <Checkbox
                    className="CurrencyEnabler-enabled"
                    disabled={props.denominationsLoading || busy}
                    checked={d.enabled}
                    onChange={async () => {
                      if (props.onEnableDenomination) {
                        await props.onEnableDenomination(d, !d.enabled);
                      }
                    }}
                  />
                </td>
                <td className="CurrencyDenominations-denomination">
                  <p>
                    {d.unitValue &&
                      d.unitValue.toLocaleString(navigator.language, {
                        minimumFractionDigits: 0
                      })}
                    s
                  </p>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default CurrencyCollection;
